import { EditTwoTone } from "@ant-design/icons";
import React from "react";

function EditColorsIcon({ colors, onEdit }) {
    return <EditTwoTone onClick={() => onEdit(colors)} style={{ cursor: "pointer" }} />;
}

export default EditColorsIcon;